import * as React from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import StocksType from './StocksType';
import latestStocks from './StocksMenuList'
import AiAssistantsModal from './AiAssistantsModal';

export default function SecFilingsSearch() {
  const [value, setValue] = React.useState<StocksType | null>(null);
  const [inputValue, setInputValue] = React.useState('');

  const [data, setData] = React.useState({
    ticker: "",
    company_name: "",
    open: "",
    change_percent: "",
    change: "",
    public_float: "",
    outstanding_shares: "",
    latest_volume: 0
  });

  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    if (value !== null) {
      const stockInput = e.currentTarget.querySelector('input[name="stock"]') as HTMLInputElement;
      if (stockInput) {
        stockInput.value = value.name;
      }
      e.currentTarget.submit();
    }
  }

  return (
    <div>
      <div className="page-header">
        <h3 className="page-title"> </h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="/">Home</a></li>
            <li className="breadcrumb-item active" aria-current="page">SEC Filings</li>
          </ol>
        </nav>
      </div>
      <div className="row">
        <div className="col-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">SEC Filings</h4>
              <p className="card-description"> Read, analyze and review SEC Filings with our AI assistant, June. <AiAssistantsModal message="Learn How it Works" /></p>
              <form className="forms-sample" action="/sec_filings_request" method="get" onSubmit={handleSubmit}>
                  <Autocomplete
                    value={value}
                    onChange={(event, newValue) => {
                      if (typeof newValue === 'string') {
                        setValue({
                          name: newValue,
                        });
                      } else if (newValue && newValue.inputValue) {
                        setValue({
                          name: newValue.inputValue,
                        });
                      } else {
                        setValue(newValue);
                        if (newValue) {
                          const stockInput = document.querySelector('input[name="stock"]') as HTMLInputElement;
                          if (stockInput) {
                            stockInput.value = newValue.name;
                          }
                          const form = document.querySelector('.forms-sample') as HTMLFormElement;
                          form?.submit();
                        }
                      }
                    }}
                    inputValue={inputValue}
                    onInputChange={(event, newInputValue) => {
                      setInputValue(newInputValue);
                    }}
                    selectOnFocus
                    clearOnBlur
                    handleHomeEndKeys
                    id="free-solo-with-text-demo"
                    className="form-group"
                    options={latestStocks}
                    getOptionLabel={(option) => {
                      // Value selected with enter, right from the input
                      if (typeof option === 'string') {
                        return option;
                      }
                      // Add "xxx" option created dynamically
                      if (option.inputValue) {
                        return option.inputValue;
                      }
                      // Regular option
                      return option.name;
                    }}
                    renderOption={(option) => option.name}
                    fullWidth
                    freeSolo
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Find a company"
                        color="primary"
                        variant="outlined"
                        name="stock"
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            e.preventDefault();
                          }
                        }}
                      />
                    )}
                  />
                  <div className="form-group">
                    <button type="submit" className="btn btn-gradient-primary">Search</button>
                  </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
